var _defs, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurveFlat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1317.04 338.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #444;\n      }\n\n      .cls-2 {\n        fill: #aaa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M570.02,311.25c-1.08-3.31-1.67-6.83-1.67-10.5s.59-7.19,1.67-10.5h-48.58c1.08,3.31,1.67,6.83,1.67,10.5s-.59,7.19-1.67,10.5h48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M457.22,311.25c-1.08-3.31-1.67-6.83-1.67-10.5s.59-7.19,1.67-10.5h-48.58c1.08,3.31,1.67,6.83,1.67,10.5s-.59,7.19-1.67,10.5h48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.63,311.25c-1.08-3.31-1.67-6.83-1.67-10.5s.59-7.19,1.67-10.5h-48.58c1.08,3.31,1.67,6.83,1.67,10.5s-.59,7.19-1.67,10.5h48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.84,311.25c-1.08-3.31-1.67-6.83-1.67-10.5s.59-7.19,1.67-10.5h-48.58c1.08,3.31,1.67,6.83,1.67,10.5s-.59,7.19-1.67,10.5h48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M805.4,63.5l-87.46,203.62c7.37.65,14.05,3.67,19.3,8.29l87.46-203.62c-7.37-.65-14.05-3.67-19.29-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.43,311.25c-1.08-3.31-1.67-6.83-1.67-10.5s.59-7.19,1.67-10.5h-48.58c1.08,3.31,1.67,6.83,1.67,10.5s-.59,7.19-1.67,10.5h48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1246.78,311.25c-1.08-3.31-1.67-6.83-1.67-10.5s.59-7.19,1.67-10.5h-48.58c1.08,3.31,1.67,6.83,1.67,10.5s-.59,7.19-1.67,10.5h48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M682.81,311.25c-1.08-3.31-1.67-6.83-1.67-10.5s.59-7.19,1.67-10.5h-48.58c1.08,3.31,1.67,6.83,1.67,10.5s-.59,7.19-1.67,10.5h48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1133.99,311.25c-1.08-3.31-1.67-6.83-1.67-10.5s.59-7.19,1.67-10.5h-48.58c1.08,3.31,1.67,6.83,1.67,10.5s-.59,7.19-1.67,10.5h48.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M937.49,267.12l-87.46-203.62c-5.24,4.62-11.93,7.64-19.29,8.29l87.46,203.62c5.24-4.62,11.93-7.64,19.3-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1021.19,311.25c-1.08-3.31-1.67-6.83-1.67-10.5s.59-7.19,1.67-10.5h-48.58c1.08,3.31,1.67,6.83,1.67,10.5s-.59,7.19-1.67,10.5h48.58Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.15,
    cy: 300.75,
    r: 28.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150.94,
    cy: 300.75,
    r: 28.15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1166.09,
    cy: 300.75,
    r: 28.15
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1053.3,
    cy: 300.75,
    r: 28.15
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.51,
    cy: 300.75,
    r: 28.15
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 827.71,
    cy: 38.15,
    r: 28.15
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 714.92,
    cy: 300.75,
    r: 28.15
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 602.12,
    cy: 300.75,
    r: 28.15
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 489.33,
    cy: 300.75,
    r: 28.15
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 376.53,
    cy: 300.75,
    r: 28.15
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 263.74,
    cy: 300.75,
    r: 28.15
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1278.89,
    cy: 300.75,
    r: 28.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveFlat);
export default __webpack_public_path__ + "static/media/curve_flat.6d414929.svg";
export { ForwardRef as ReactComponent };